export enum PropertyType {

  STRING = 'string',
  NUMBER = 'number',
  BOOLEAN = 'boolean',
  ARRAY = 'array',
  PROPERTY = 'property',
  DESCRIPTOR = 'descriptor'

}
